import React from 'react';

export const nav = (token) => {

 const navItems = { 
    items: [
      /*{
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer',        
      },*/     
      {
        name: 'Klanten bekijken',
        url: '/clients',
        icon: 'icon-people',        
      },
      {
        name: 'Adressen bekijken',
        url: '/addresses',
        icon: 'icon-location-pin',       
      },
      {
        name: 'Berichten overzicht',
        url: '/messages',
        icon: 'icon-envelope',       
      },
      {
        name: 'Bestanden',
        url: '#',
        icon: 'icon-docs',  
        is_admin: 1,
        children: [           
        {
          name: 'Bestanden bekijken',
          url: '/files',
          icon: 'icon-eye'
        },
           
        
        {
          name: 'Type toevoegen',
          url: '/filetype/add',
          icon: 'icon-plus'
        },
        {
          name: 'Types bekijken',
          url: '/filetype/view',
          icon: 'icon-eye'
        },

        ]
      },
      {
        name: 'Metadata',
        url: '#',
        icon: 'icon-shuffle',  
        is_admin: 1,
        children: [
        {
          name: 'Categorie toevoegen',
          url: '/filemetadatacategory/add',
          icon: 'icon-plus'
        },
        {
          name: 'Categorie bekijken',
          url: '/filemetadatacategory/view',
          icon: 'icon-eye'
        },
        {
          name: 'Waarde toevoegen',
          url: '/filemetadatavalue/add',
          icon: 'icon-plus'
        },
        {
          name: 'Waarde bekijken',
          url: '/filemetadatavalue/view',
          icon: 'icon-eye'
        },
        ]
      },
      {
        name: 'Gebruiker',
        url: '#',
        icon: 'icon-user-follow',  
        children: [
        {
          name: 'Toevoegen',
          url: '/user/add',
          icon: 'icon-plus'
        },
        {
          name: 'Overzicht',
          url: '/user/view',
          icon: 'icon-eye'
        }        
        ]
      },
      {
        name: 'Rapportage',
        url: '#',
        icon: 'icon-note',  
        children: [
        {
          name: 'Rapportage toevoegen',
          url: '/report/add',
          icon: 'icon-plus'
        },
        /*{
          name: 'Globaal toevoegen',
          url: '/report/addGlobal',
          icon: 'icon-plus'
        },*/
        {
          name: 'Overzicht',
          url: '/report/view',
          icon: 'icon-eye'
        }        
        ]
      }
    ]    
}

  return navItems;
};




// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js